{
  "error-handler-service": {
    "backend-message": {
      "customer": {
        "blackListed": "Ihre Online-Buchungsoption bei diesem Salon ist gesperrt. Bitte kontaktieren Sie den Salon, um einen neuen Termin zu buchen",
        "existed": "Konto ist bereits vorhanden",
        "notFound": "Konto konnte nicht gefunden werden",
        "credentialNotMatched": "PIN-Code ist ungültig. Bitte versuchen Sie es erneut!",
        "numberOfCredentialFailedMatchesAlreadyExceedMax": "Die Anzahl der Wiederholungen wurde überschritten. Bitte kontaktieren Sie das Studio für weitere Unterstützung",
        "customerNumberOfCredentialResendExceedMax": "Die Anzahl der Wiederholungen wurde überschritten. Bitte kontaktieren Sie das Studio für weitere Unterstützung",
        "waitingPeriodBeforeResendNotOverYet": "Bitte haben Sie etwas Geduld, bis Sie den PIN-Code nach etwa einer Minute erneut senden können"
      },
      "businessObject": {
        "alreadyCheckedIn": "Bereits eingecheckt. Bitte versuchen Sie es nach ein paar Minuten noch einmal",
        "notFound": "Studio konnte nicht gefunden werden"
      },
      "credit-package-order": {
        "no-capture-payments": "Kreditpaketbestellung fehlgeschlagen",
        "order-already-fulfilled": "Kreditpaketauftrag wurde bereits erfüllt",
        "order-already-rejected": "Kreditpaketbestellung wurde abgelehnt"
      },
      "email": {
        "exists-confirmed-and-not-changeable": "Sobald eine E-Mail bestätigt wurde, kann sie nicht mehr geändert werden!"
      },
      "error": {
        "email-exists": "Aus Sicherheitsgründen akzeptieren wir eine eindeutige E-Mail in Verbindung mit einer eindeutigen Telefonnummer. Ihre Telefonnummer ist mit einer E-Mail verknüpft, die bereits in Gebrauch ist. Bitte versuchen Sie, sich mit Ihrer E-Mail-Adresse anzumelden.",
        "invalid-code": "PIN-Code ist ungültig. Bitte versuchen Sie es erneut!",
        "phoneNr-exists": "Aus Sicherheitsgründen akzeptieren wir eine eindeutige E-Mail in Verbindung mit einer eindeutigen Telefonnummer. Ihre E-Mail ist mit einer Telefonnummer verknüpft, die bereits in Gebrauch ist. Bitte versuchen Sie, sich mit Ihrer Telefonnummer anzumelden."
      },
      "review": {
        "notFound": "Ungültige oder abgelaufene URL"
      },
      "startTime": {
        "invalid": "Das ausgewählte Zeitfenster ist nicht mehr verfügbar. Bitte wählen Sie ein anderes Zeitfenster!"
      },
      "user-challenge": {
        "too-much-requests": "Sie haben häufig angefragt. Bitte versuchen Sie es nach ein paar Sekunden erneut"
      },
      "Unauthorized": "Bitte melden Sie sich erneut mit der richtigen E-Mail-Adresse und dem richtigen Passwort an!",
      "appointment duration is too long, max 4 hours": "Die maximale Dauer beträgt 4 Stunden. Bitte ändern Sie Ihre ausgewählten Services.",
      "No available slot at desired start time": "Das ausgewählte Zeitfenster ist nicht mehr verfügbar. Bitte wählen Sie ein anderes Zeitfenster!",
      "confirmed appointment already exists at same time": "Sie haben bereits einen Termin zur gleichen Zeit gebucht",
      "customer already has maximum number of confirmed appointments": "Die maximale Anzahl von Terminen in diesem Salon ist erreicht. Bitte kontaktieren Sie den Salon, um einen neuen Termin zu buchen"
    },
    "text": {
      "server-connection-error": "Keine Verbindung zum Server",
      "general-error": "Hoppla! Etwas ist schief gelaufen. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
    }
  }
}
